import { INotaBlog } from '@/shared/model/nota-blog.model';
import { ISeccionBlog } from '@/shared/model/seccion-blog.model';

export const SECCIONES_VALIDAS = ['inicio', 'quienes', 'novedades', 'servicios', 'cuota', 'formularios', 'contacto'] as const;

export type CategoriaNovedad = 'institucional' | 'actividades' | 'finanzas';

export interface INovedad {
  id: number;
  titulo: string;
  categoria: CategoriaNovedad;
  fecha: string;
  texto: string;
  imagen?: string;
}

export interface IMiembroComision {
  id: number;
  iniciales: string;
  cargo: string;
  nombre: string;
}

export interface IHistorialCuota {
  id: number;
  anio: number;
  nota?: string;
  mensual: number | null;
  cuotas: number;
  semestral: number | null;
  anual: number | null;
  vigente: boolean;
}

export const COLOR_CATEGORIA: Record<CategoriaNovedad, string> = {
  institucional: '#5b4a9b',
  actividades: '#4a8c3f',
  finanzas: '#f05a1a',
};

export function formatMonto(valor: number | null): string {
  return valor === null ? '—' : `$${valor.toLocaleString('es-AR')}`;
}

const CATEGORIA_BACKEND_A_DISPLAY: Record<string, CategoriaNovedad> = {
  INSTITUCIONAL: 'institucional',
  ACTIVIDADES: 'actividades',
  FINANZAS: 'finanzas',
};

const MESES = [
  'enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio',
  'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre',
];

export function formatFechaNota(fecha?: string | Date | null): string {
  if (!fecha) {
    return '';
  }
  const fechaObj = typeof fecha === 'string' ? new Date(fecha) : fecha;
  const mes = MESES[fechaObj.getUTCMonth()];
  return `${mes.charAt(0).toUpperCase()}${mes.slice(1)} ${fechaObj.getUTCFullYear()}`;
}

export function notaANovedad(nota: INotaBlog, secciones: ISeccionBlog[]): INovedad {
  const fotoSeccion = secciones.find(seccion => seccion.tipo === 'FOTO' && !!seccion.imagen);
  return {
    id: nota.id!,
    titulo: nota.titulo ?? '',
    categoria: CATEGORIA_BACKEND_A_DISPLAY[nota.categoria ?? 'INSTITUCIONAL'] ?? 'institucional',
    fecha: formatFechaNota(nota.fechaCreacion),
    texto: nota.resumen ?? '',
    imagen: fotoSeccion ? `data:${fotoSeccion.imagenContentType};base64,${fotoSeccion.imagen}` : undefined,
  };
}
